import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Form, Modal, Table } from "react-bootstrap";

const API_URL = process.env.REACT_APP_API_URL;

const TeamLevelList = () => {
  const [levels, setLevels] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentLevel, setCurrentLevel] = useState({ id: null, name: "" });

  const fetchLevels = async () => {
    try {
      const res = await axios.get(`${API_URL}/team-levels`);
      setLevels(res.data);
    } catch (error) {
      console.error("Error fetching team levels:", error);
    }
  };

  useEffect(() => {
    fetchLevels();
  }, []);

  const handleClose = () => {
    setShowModal(false);
    setCurrentLevel({ id: null, name: "" });
  };

  const handleShowAdd = () => {
    setIsEditing(false);
    setCurrentLevel({ id: null, name: "" });
    setShowModal(true);
  };

  const handleShowEdit = (level) => {
    setIsEditing(true);
    setCurrentLevel(level);
    setShowModal(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isEditing) {
      await axios.put(
        `${API_URL}/team-levels/${currentLevel.id}`,
        currentLevel,
      );
    } else {
      await axios.post(`${API_URL}/team-levels`, currentLevel);
    }
    fetchLevels();
    handleClose();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Bạn có chắc chắn muốn xóa hạng đội này?")) {
      await axios.delete(`${API_URL}/team-levels/${id}`);
      fetchLevels();
    }
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Quản lý Hạng Đội</h2>
        <Button variant="primary" onClick={handleShowAdd}>
          Thêm Hạng Đội
        </Button>
      </div>

      <Table striped bordered hover>
        <thead className="table-light">
          <tr>
            <th>ID</th>
            <th>Tên Hạng</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          {levels.map((level) => (
            <tr key={level.id}>
              <td>{level.id}</td>
              <td>{level.name}</td>
              <td>
                <Button
                  variant="warning"
                  size="sm"
                  onClick={() => handleShowEdit(level)}
                >
                  Sửa
                </Button>{" "}
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => handleDelete(level.id)}
                >
                  Xóa
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {isEditing ? "Sửa Hạng Đội" : "Thêm Hạng Đội"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Tên Hạng</Form.Label>
              <Form.Control
                type="text"
                value={currentLevel.name}
                onChange={(e) =>
                  setCurrentLevel({ ...currentLevel, name: e.target.value })
                }
                required
              />
            </Form.Group>
            <Button variant="secondary" onClick={handleClose} className="me-2">
              Hủy
            </Button>
            <Button variant="primary" type="submit">
              Lưu
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TeamLevelList;
